var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.0703125,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#F0F2FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8191 26.5251V28.3891H25.0203V29.7314H19.2755V28.3891H21.4767V26.5251C19.0211 26.2006 17.1316 24.1012 17.1316 21.5565V19.7561H18.4739V21.5565C18.4739 22.5744 18.8875 23.4841 19.5491 24.1521C20.2171 24.8201 21.1268 25.2273 22.1447 25.2273C23.1626 25.2273 24.0723 24.8201 24.7403 24.1521C25.4083 23.4841 25.8155 22.5744 25.8155 21.5565V19.7561H27.1578V21.5565C27.1578 24.1012 25.2684 26.1943 22.8191 26.5251ZM20.2409 23.4603C20.242 23.4614 20.2431 23.4625 20.2443 23.4636C20.732 23.948 21.4037 24.2475 22.1447 24.2475C22.8874 24.2475 23.5605 23.9467 24.0485 23.4603C24.5372 22.9731 24.8404 22.2999 24.8421 21.5565C24.8421 21.5544 24.8421 21.5523 24.8421 21.5501V16.4289C24.8421 14.9402 23.6334 13.7314 22.1447 13.7314C20.656 13.7314 19.4473 14.9402 19.4473 16.4289V21.5501C19.4473 21.5523 19.4473 21.5544 19.4473 21.5565C19.449 22.2999 19.7522 22.9731 20.2409 23.4603ZM22.1447 23.2475C23.0811 23.2475 23.8421 22.4865 23.8421 21.5501V16.4289C23.8421 15.4925 23.0811 14.7314 22.1447 14.7314C21.2083 14.7314 20.4473 15.4925 20.4473 16.4289V21.5501C20.4473 22.4865 21.2083 23.2475 22.1447 23.2475Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5147 14.0849C14.3194 14.2802 14.3194 14.5968 14.5147 14.792L30.7781 31.0555C30.9734 31.2507 31.29 31.2507 31.4852 31.0555C31.6805 30.8602 31.6805 30.5436 31.4852 30.3484L15.2218 14.0849C15.0265 13.8897 14.7099 13.8897 14.5147 14.0849Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioDisable);
export default __webpack_public_path__ + "static/media/audioDisable.d62306a1658b12a5831158ad214fe355.svg";
export { ForwardRef as ReactComponent };